<mat-card class="afiliaciones">
    <mat-card-header>
        <mat-card-title>Afiliados portafolio</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mt-4">
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <div *ngIf="!mostrarCargando" class="text-center">
            <apx-chart [series]="chartOptions.series" [legend]="chartOptions.legend" [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis" [colors]="chartOptions.colors"
                [stroke]="chartOptions.stroke" [title]="chartOptions.title" [subtitle]="chartOptions.subtitle" [tooltip]="chartOptions.tooltip" [responsive]="chartOptions.responsive" [labels]="chartOptions.labels" [fill]="chartOptions.fill" [states]="chartOptions.states"
                [theme]="chartOptions.theme" class="chartportafolio"></apx-chart>
        </div>
    </mat-card-content>
</mat-card>